import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo1 } from "../../../routes/Module1";
import Imagen1 from "../../../images/modulo1/libromaria1.png";
import Imagen2 from "../../../images/modulo1/libromaria2.png";
import Imagen3 from "../../../images/modulo1/libromaria3.png";
import Imagen4 from "../../../images/modulo1/libromaria4.png";

import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo1/Actividad8.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo1.content[0];
  const infoAct = modulo1.content[0].activities[7];
  const crumbs = [
    {
      title: modulo1.title,
      url: "/" + modulo1.url,
    },
    {
      title:
        modulo1.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `Cierre`,
    linkNext: `${modulo1.url}/cierre`,
    titlePrev: `${modulo1.content[0].activities[6].name}`,
    linkPrev: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo1.color,
    title: `${modulo1.title} - ${infoAct.name}`,
    name: modulo1.title
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo1.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">Actividad 8</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          Ahora ilustra tu historia. Para ello, usarás algunos de los
          datos que recogiste en la actividad anterior.
        </li>
        <li>Trabaja con hojas de papel y colores o plumones.</li>
        <li>Acá tienes como ejemplo con la historia de María García.</li>
      </ul>
      <div className="row mt-5">
        <div className="col-md-5">
          <div>
            <p>
              <strong>Página 1:</strong> Dibújate y ponle nombre a tu libro.
            </p>
          </div>
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-5">
          <div>
            <p>
              <strong>Página 2:</strong> Escribe tu nombre y apellido y tu edad.
              Añade de dónde viene tu familia.
            </p>
          </div>
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-5">
          <div>
            <p>
              <strong>Página 3:</strong> Dibuja a los adultos que te cuidan y
              escribe sus nombres.
            </p>
          </div>
          <img src={Imagen3} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-5">
          <div>
            <p>
              <strong>Página 4:</strong> Dibuja a toda tu familia junta.
            </p>
          </div>
          <img src={Imagen4} alt="Familia" className="img-fluid" />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Explique qué harán y que para eso verán un
          modelo. Consiga dos hojas de papel. Cada hoja será doblada por la
          mitad y así tendremos las 4 páginas. Finalice destacando las
          semejanzas y diferencias entre el nuevo libro y el modelo.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
